import { Component, OnInit,ViewChild,TemplateRef,Input, group } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
import { GroupService } from '../../service/group.service';
import { commonService } from '../../service/common.service';

@Component({
  selector: 'app-groupmembers',
  templateUrl: './groupmembers.component.html',
  styleUrls: ['./groupmembers.component.css'],
  providers:[GroupService]
})
export class GroupmembersComponent implements OnInit {

  @ViewChild('group') public creategroup: TemplateRef<any>;
  modalReference:NgbModalRef;
  msg:any;
  isError=false;
  isSuccess=false;
  groupIcon ='';
  formvailidation=false;
  title:any;
  aboutGroup='';
  groupPrivacy='';
  groups:any=[];
  filterform:any;
  autoload:any;
  user:any;
  grouptitle:any;
  group:any;
  groupdetails:any;
  searchtxt:any;
  groupsLoder=true;
  isclickbutton=false;
  passcode:string;
  ispasscode=false;
  currentEditObj:any;
  ismygroup=false;
  countmember:any;
  userviewmore=false;
  isclickViewMore=false;
 

  readonly rootUrl = this.global.siteUrl;
  readonly profileUrl  =  this.global.profileUrl;
  url =this.rootUrl+'file/upload?folder='+this.global.groupProfileFolder;
  path=this.global.profileUrl;
  @Input() fileExt: string = "";
  errors: Array<string> =[];
  fileExtExists=false;
  attactmentlist:number;
  Group={'title':'Groups','desciprtion':'desciprtion'};
  groupObj:any;
  groupId:string
  

  constructor(private route:ActivatedRoute,private _common:commonService,private modalService: NgbModal,private global:Globals,private _group:GroupService,private router:Router) { 
    this.group= {};
  }

  ngOnInit() {
    // get user details
    this.route.params.subscribe(params => {
      //  this.groupId = atob(decodeURIComponent(params.id)); 
        this.groupId = params.id; 
   })
   // get user details
   this._common.profile.subscribe((data: any) => {
    if(data){
      this.user=data;  
      }else{
        this.user={}; 
      } 
  });
   this.getgroup();
   this.getGroupMembers();
   
   
  }

  getgroup(){
    this._group.getGroupDetails({group:this.groupId}).subscribe((data : any)=>{
    
      if(data.error==0){ 
        this.grouptitle = data.results.title;
       
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        this.msg = data.message;
        this.isError = true;
        this.isSuccess = false;
        }
      }
  },
      (error : HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
      });
  }

  getGroupMembers(){
    this.isclickViewMore = true;
   
    this._group.groupUser({groupId:atob(decodeURIComponent(this.groupId)),search:this.searchtxt,start:this.groups.length ? this.groups.length : 0,end:10}).subscribe((data : any)=>{
      this.isclickViewMore = false;
      if(data.error==0){ 
        this.groupsLoder=false;
        Array.prototype.push.apply(this.groups, data.results.rows);
        this.countmember  = data.results.count.length;
        if (this.countmember > this.groups.length) {
          this.userviewmore = true;
        } else {
          this.userviewmore = false;
        }
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        this.msg = data.message;
        this.isError = true;
        this.isSuccess = false;
        }
      }
  },
      (error : HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
      });
  
  } 
  

needLogin(){
  this._common.setLoginBox(true);        
}


filteruser(search){

   this.searchtxt = search;
   this.groups=[];
   this.getGroupMembers();
}

backgroup(){
  this.router.navigate(['/groups/'+this.groupId]);
}

customdecode(data){   
  return encodeURI(btoa(data));
 }
 usermore(){
   this.getGroupMembers();
 }


 makegroupadmin(mem){
   mem.isclickbutton=true;
   this._group.makegroupadmin({group:mem.groupId,userId:mem.userId,guType:'Admin'}).subscribe((data : any)=>{
    mem.isclickbutton=false;
    if(data.error==0){ 
     
      mem.groupUserType='Admin';
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      this.msg = data.message;
      this.isError = true;
      this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
  
 })

}

removegroupadmin(mem){

  if(confirm("do you want to remove group admin?")){
    mem.isclickbutton=true;
  this._group.makegroupadmin({group:mem.groupId,userId:mem.userId,guType:'User'}).subscribe((data : any)=>{
    mem.isclickbutton=false;
    if(data.error==0){ 
      mem.groupUserType='User';
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      this.msg = data.message;
      this.isError = true;
      this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
  
 })
}
}

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/groupmembers/groupmembers.component.ts